import Model from '@ember-data/model';

import { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { load } from 'ember-async-data';

import filterEmptyItemModels from 'rise-ui/utils/filter-empty-item-models.js';
import groupItemModels from 'rise-ui/utils/group-item-models.js';

export default class CatalogRecordModel extends Model {
  @attr('string') title;
  @attr('string') description;
  @attr programNames;
  @attr('string') generationEffort;
  @attr('number') generationEffortId;
  @attr metadataItemId;
  @attr('string') metadataStandard;
  @attr('boolean') recordActiveFlag;
  @attr('string') subThemeId;
  @attr themes;
  @attr tags;
  @attr('date') createDate;

  @hasMany('item', { async: true, inverse: 'catalogRecord' }) items;
  @cached get asyncItems() {
    return load(this.items);
  }
  @cached get validItems() {
    return this.asyncItems.isPending ? [] : filterEmptyItemModels(this.asyncItems.value);
  }
  @cached get groupedItems() {
    return groupItemModels(this.validItems);
  }

  @belongsTo('location', { async: true, inverse: 'catalogRecords' }) location;
}
